import { styled } from '@mui/material/styles';
import { MenuItem } from '@mui/material';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { BORDER_RADIUS } from '@src/styles/config';

export const StyledSelect = styled('div')`
  width: 100%;
  .input-error {
    color: ${COLOR.functionalRed.default};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
  }
  .MuiOutlinedInput-root {
    border-radius: ${({ customStyle }) =>
      customStyle?.borderRadius || BORDER_RADIUS};
    height: ${({ customStyle }) => customStyle?.height};
    width: ${({ customStyle }) => customStyle?.width};
    background-color: ${({ customStyle }) => customStyle?.backgroundColor};
    font-size: ${({ customStyle }) => customStyle?.fontSize};
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    font-weight: 500;
    font-size: ${(props) => props.fontSize || '16px'};
    &:focus {
      color: ${COLOR.white};
      background-color: ${COLOR.light};
      &:hover {
        background-color: ${COLOR.light};
        color: ${COLOR.white};
      }
    }
    &:hover {
      background-color: ${TRANSPARENT_COLOR.light};
      &.MuiListItemIcon-root,
      &.MuiListItemText-primary {
        color: ${COLOR.white};
      }
    }
  }
`;
